import { createPutAsyncSlice } from '@sonar-software/xuder';
import { getCoreBusinessContextSlice } from '../get';
import { putBusinessContextUpload } from '@api';

export const putCoreBusinessContextUploadSlice = createPutAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ getCoreBusinessContextSlice.asyncActionCreators.requestGetCoreBusinessContext ]
	},
	name: 'CoreBusinessContextUpload',
	receive: false,
	request: true,
	requestHandler: putBusinessContextUpload
});
